import * as yup from 'yup'

export const schemaUpdateContact = yup.object().shape({
    contact_name: yup.string().required('Contact name is required'),
    contact_email: yup
        .string()
        .email('Invalid email format')
        .required('Email is required'),
    contact_phone: yup.string().required('Phone is required'),
    contact_position: yup.string().nullable(),
    contact_source: yup.string().required('Chưa chọn nguồn'),
    contact_industry: yup.string(),
    contact_language: yup.string(),
    contact_roles: yup.array().of(yup.string()).required(),
    contact_service_interestings: yup.array(),
    contact_cs_followers: yup.array().nullable(),
    contact_sale_followers: yup.array().nullable(),
    contact_channel: yup.array().nullable(),
    contact_address: yup.string().nullable(),
    contact_note: yup.string().nullable(),
    // Affiliate picker: number when selected, '' when cleared -> coerce to null.
    affiliate_id: yup
        .number()
        .transform((value, original) =>
            original === '' || original === null || original === undefined
                ? null
                : value
        )
        .nullable(),
})
